<template>
  <div class="modal fade" :id="modalId" ref="editModalEl" tabindex="-1" :aria-labelledby="`${modalId}-label`" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title" :id="`${modalId}-label`">Edit Vacancy</div>
        <button class="btn btn-default btn-sm close-btn" @click="handleClose">
            <CloseIcon/>
        </button>
      </div>
      <div class="modal-body">
        <form class="modal-form">
            <div class="mb-1 m-control">
            <label class="form-label">Job Title</label>
                <input type="text" v-model="editVacancy.jobTitle" class="form-control" placeholder="General Manager, Assistant etc.">
            </div>
            <div class="mb-1 m-control">
                <label class="form-label">Location</label>
                 <select class="form-control" v-model="editVacancy.location">
                    <option value="" selected>Select a Job Location</option>
                    <option v-for="district in pagecontent.districts" :value="district">{{ district }}</option>
                </select>
            </div>
            <div class="mb-3 m-control">
                <label class="form-label">Closing Date</label>
                <input type="date" v-model="editVacancy.closingDate" class="form-control">
            </div>
             <div class="mb-3 m-control">
                <label class="form-label">Job Type</label>
                <select class="form-control"  v-model="editVacancy.jobType">
                    <option value="" selected>Select a Job Type</option>
                    <option v-for="jobtype in pagecontent.jobTypes" :value="jobtype">{{ jobtype }}</option>
                </select>
            </div>
            <div class="mb-1 m-control">
                <div ref="vacancyEditor" class="custom-quill"></div>
            </div>

        </form>
         <!-- errors -->
        <div class="errors" v-if="hasErrors" style="margin-top:1rem;">
            <div class="error" v-for="error in errors">{{ error }}</div>
        </div>
        <!-- errors -->  
         
      </div>
      <LoadingIndicator v-if="loading"/>
      <div class="modal-footer" v-if="!loading">
        <button type="button" @click="updateVacancyAsync" class="btn btn-primary" style="color:white;background:var(--tertiary);border:0px;">Update Vacancy</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import {Modal} from 'bootstrap';
import store from '@/store';
import { editVacancyAsync } from '@/services/employers/vacancyService';
import LoadingIndicator from '../Utility/LoadingIndicator.vue';
import pagecontent from '@/assets/text.json'
import CloseIcon from '../IconComponents/CloseIcon.vue';
export default {
    components:{
        LoadingIndicator, CloseIcon
    },
    props:{      
        vacancy:{
            type: Object,
            required: false
        },
         modalId:{
            type: String
        },
        closeModalOnSuccess: {
            type: Function,
            required: true
        }
    },
    data(){
        return{
             pagecontent,
             editVacancy:{
                jobTitle:"",
                location:"",
                description:"",
                jobType:"",
                closingDate:"",
                jobId:""
            },
            errors:[],
            loading:false,
            hasErrors:false
        }
    },
    mounted(){
         this.modalInstance = new Modal(this.$refs.editModalEl);
         this.setVacancy();
        this.setupQuill();
    },
    watch: {
        vacancy(newVal) {
            if (newVal) {
                this.setVacancy();
                if (this.quill) {
                    this.quill.root.innerHTML = newVal.description || '';
                }
            }
        }
    },
    methods:{
       async updateVacancyAsync(){
            try{
            this.loading = true;
            this.hasErrors = false;
            this.errors = [];
            var response = await editVacancyAsync(this.editVacancy, () => this.hide());
            if(!response.success){         
                    if(!response.errors){
                        const err = new Error(response.message, {reason: response.caption});
                        err.caption = response.caption;
                        throw err;
                    }else{
                        this.errors = response.errors;
                        this.loading = false;
                        this.hasErrors = true
                    }
                }else{
                    this.loading = false;
                    this.$store.dispatch("employerVacancies/editVacancy", response.vacancy);
                    
                    if(typeof this.closeModalOnSuccess === 'function'){
                        this.closeModalOnSuccess(this.editVacancy.jobTitle);
                    }
                }
            }catch(e){
                this.errors.push(e.message);
                this.loading = false;
                this.hasErrors = true;
            }
        },
        setVacancy(){
            if(this.vacancy != null){
                this.editVacancy.jobTitle = this.vacancy.jobTitle;
                this.editVacancy.location = this.vacancy.location;
                this.editVacancy.description = this.vacancy.description;
                this.editVacancy.jobType = this.vacancy.jobType;
                this.editVacancy.closingDate = this.formatDateForInput(this.vacancy.closingDate);
                this.editVacancy.jobId  = this.vacancy.jobId;
            }
        },
        formatDateForInput(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return '';
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        setupQuill(){
                // Initialize Quill
            this.quill = new Quill(this.$refs.vacancyEditor, {
            theme: 'snow',
            modules: {
                toolbar: [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' },
                 { list: 'bullet' }],
                ['link']
                ]
            }
            });
            //set present values
            if(this.editVacancy && this.editVacancy.description != null){
                let formatted = this.formattedDescription(this.editVacancy.description);
                this.quill.root.innerHTML =  formatted;
            }

            // Listen for changes and update Vue data
            this.quill.on('text-change', () => {
                if(this.editVacancy) {
                    this.editVacancy.description = this.quill.root.innerHTML;
                }
            })
    },
     show() {
        this.modalInstance?.show();
      },
      hide() {
        this.modalInstance?.hide();
      },
      handleClose() {
        this.hide();
      },
      formattedDescription(description) {
          if (!description) return '';

          let updated = description;

          // 1. Style <p> tags with your theme colors
          updated = updated.replace(
            /<p(\s[^>]*)?>/g,
            '<p style="background-color:transparent;color:var(--foreground);padding:0rem;border-radius:0px;margin-bottom:0rem;"$1>'
          );

          // 2. Remove inline background-color
          updated = updated.replace(
            /background-color:\s*[^;"]+;?/gi,
            ''
          );

          // 3. Remove inline text color
          updated = updated.replace(
            /color:\s*[^;"]+;?/gi,
            ''
          );

          // 4. Optional: remove empty paragraphs
          updated = updated.replace(/<p[^>]*><br><\/p>/g, '');
        
          return updated;
    }
    }
}
</script>
<style scoped>
    input, label{
        font-size:0.9rem;
    }
    .modal-form{
        display: grid;
        column-gap:1rem;
        grid-template-columns: repeat(2,1fr);
        grid-template-rows: repeat(4,auto);
    }

    .m-control:nth-child(3){
        grid-column:1/2;
    }
    .m-control:last-child{
        grid-column:1/3;
    }
      /* MODAL */
    .modal-body{
        color:var(--foreground);
    }

   
    
</style>